import { useCookies } from 'react-cookie'

import { useActionless } from 'redux/hooks'
import { TOGGLE_MODAL } from 'redux/active/actions/types'

import { hideTagRecommendationsKeyForNow } from 'components/accountSettingsPage/BrowserSpecificSiteSettings'

import Icon from 'components/elements/Icon'

import styles from './tagModal.module.scss'

const TagModal = () => {
  const [toggleModal] = useActionless(TOGGLE_MODAL)

  const [_, setCookies] = useCookies([hideTagRecommendationsKeyForNow])

  const handleOpenTagMenu = () => {
    toggleModal({ modalName: 'deckTags', flag: true })
  }

  const handleCloseTagReminder = () => {
    setCookies(hideTagRecommendationsKeyForNow, true, {
      path: '/',
    })
  }

  return (
    <div className={`${styles.menuContainer}`}>
      <div className={styles.info}>
        <h4>Consider setting deck tags</h4>
      </div>
      <div className={styles.controls}>
        <button className={styles.button} onClick={handleOpenTagMenu}>
          <Icon name="tags" /> <span>Tags</span>
        </button>

        <button className={styles.button} onClick={handleCloseTagReminder}>
          <Icon name="close" /> <span>Close</span>
        </button>
      </div>
    </div>
  )
}

export default TagModal
